import { normalize, schema } from 'normalizr'

import httpClient from 'utils/httpClient'

interface FetchInviteResponse {
  id: number
  rfp: number
  invite_email_sent_at: string
  rate_type: string
  carrier: Carrier
}

interface CarrierInviteNormalized {
  carrierInvites: Record<number, Omit<CarrierInvite, 'meta'>>
  carriers: Record<number, Carrier>
}

function getCarrierId(value: CarrierInvite | FetchInviteResponse): string {
  if (typeof value.carrier === 'number') {
    return value.carrier.toString()
  }

  return value.carrier.id.toString()
}

function normalizeCarrierInviteList(
  data: FetchInviteResponse[]
): CarrierInviteNormalized {
  const normalized = normalize(data, [
    new schema.Entity<CarrierInvite>(
      'carrierInvites',
      {
        carrier: new schema.Entity<Carrier>('carriers', undefined, {
          processStrategy: (entity: Carrier, parent: FetchInviteResponse) => ({
            ...entity,
            invite: parent.id,
          }),
        }),
      },
      {
        idAttribute: getCarrierId,
        processStrategy: ({ invite_email_sent_at, ...entity }) => ({
          ...entity,
          email_sent_at: invite_email_sent_at ?? null,
        }),
      }
    ),
  ])

  // HACK: we have to convert to unknown before we can convert to CarrierInviteNormalized
  const entities = (normalized.entities || {}) as unknown

  return entities as CarrierInviteNormalized
}

export const list = async (rfpId: string | number) => {
  const { data } = await httpClient.get(
    `/api/proposals/${rfpId}/carrier_invite/`
  )
  return normalizeCarrierInviteList(data)
}

export const create = async (invite: Partial<CarrierInvite>) => {
  const { data } = await httpClient.post(
    `/api/proposals/${invite.rfp}/carrier_invite/`,
    invite
  )
  return data
}

export const remove = async (invite: CarrierInvite) => {
  const { data } = await httpClient.delete(
    `/api/proposals/${invite.rfp}/carrier_invite/${invite.id}/`
  )
  return data
}
